import { Profile } from 'Core/common/Profile/types'
import { Http, HttpUser } from 'Core/utils/axios'

import { baseSupplierUrl, baseUsersUrl } from './constants'

const retrieveProfile = (): Promise<Profile.Basic> => HttpUser.get(baseUsersUrl)

const retrieveProfileInfo = (): Promise<Profile.Info[]> =>
	Http.get(`${baseSupplierUrl}/profile-info`)

const updateProfile = (params: Profile.Request.Edit): Promise<Profile.Basic> =>
	HttpUser.put(baseUsersUrl, params)

const retrieveLocales = (): Promise<Profile.Locale[]> => HttpUser.get(`${baseUsersUrl}/locales`)

export { retrieveProfile, updateProfile, retrieveLocales, retrieveProfileInfo }
